import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TargetAccount} from '../../../../../target/target.model';

@Component({
  selector: 'app-shared-accounts-icon',
  template: `
    <div class="target-account-name">{{target.targetName}}</div>
  `,
  styleUrls: ['./shared-accounts-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SharedAccountsIconComponent {
  @Input() target!: TargetAccount;

}
